import { render, staticRenderFns } from "./ChannelRecharge.vue?vue&type=template&id=098acffc&scoped=true&"
import script from "./ChannelRecharge.vue?vue&type=script&lang=js&"
export * from "./ChannelRecharge.vue?vue&type=script&lang=js&"
import style0 from "./ChannelRecharge.vue?vue&type=style&index=0&id=098acffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098acffc",
  null
  
)

export default component.exports